module.exports = __webpack_public_path__ + "img/shenqing.59439788.png";